  export const maskMobileNumber = (mobile) => {
  if (!mobile || mobile.length <= 3) return mobile;

  const firstChar = mobile[0];
  const lastTwo = mobile.slice(-2);
  const masked = "X".repeat(mobile.length - 3); // minus 1 (first char) and 2 (last two chars)
  return `${firstChar}${masked}${lastTwo}`;
};

export function maskEmail(email) {
  const [localPart, domain] = email.split("@");

  if (!domain || localPart.length <= 2) {
    return email; // Not a valid email or too short to mask
  }

  const firstTwo = localPart.slice(0, 1);
  const lastChar = localPart.slice(-1);
  const middle = "X".repeat(localPart.length - 3);

  return `${firstTwo}${middle}${lastChar}@${domain}`;
}

